import React, { useState, useEffect, useLayoutEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Link, Redirect, useHistory, useLocation } from "react-router-dom";
import { setAlert } from "../../actions/alert";
import Alert from "../../components/alert/Alert";
import { Icon } from "react-icons-kit";
import { filter } from "react-icons-kit/fa/filter";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Select from "react-bootstrap";
import {
  postJobGetAll,
  deleteJob,
  complexityGetbyId,
  complexityGet,
  expectedDurationGetbyId,
  paymentTypeGetbyId,
  skillsGetbyId,
} from "../../actions/postJob";
import { skillsGet } from "../../actions/clientProfile";
import {
  freelancerStatusGet,
} from "../../actions/freelancerProfile";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { Country } from "country-state-city";
import { Input2 } from "../../components/input/input";
import { SVGLocation } from "../../components/SVG";
import moment from "moment";
import Search from "./search";
import Skeleton from "./../../components/skeleton";

const Job = ({
  clientProfile: { skills },
  freelancerProfile: { freelancerStatus, freelancerprofile, isfreelancerActionable },
  auth: { isAuthenticated, user },
  postJob: { postJobDataAll, applyforjob, jobDetailData, complexityLevel },
  postJobGetAll,
  skillsGet,
  complexityGet,
}) => {
  let history = useHistory();
  const [filteredJobData, setFilteredJobData] = useState([]);
  const [postJobData1, setPostJobData] = useState(null);
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [selectedjob, setSelectedJob] = useState(null);
  const [showjob, setShowJob] = useState(false);
  const handleClosejob = () => {
    setShowJob(false);
  };

  useLayoutEffect(() => {
    //dispatch(freelancerStatusGet())

    postJobGetAll();
    skillsGet();
    complexityGet();
    if (storedValue) {
      setValue(storedValue);
    }
  }, []);

  const [showpage, setShowPage] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [jobsPerPage] = useState(10);

  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  // const currentJobs = postJobData1 ? [...postJobData1].slice(indexOfFirstJob, indexOfLastJob) : null;

  let currentJobs = postJobData1 ? [...postJobData1].slice(indexOfFirstJob, indexOfLastJob) : null;

  currentJobs = currentJobs ? currentJobs.reverse() : null;
  
  const totalPages = Math.ceil(postJobData1?.length / jobsPerPage);
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    document.title = 'Find Work';
  }, []);

  useEffect(() => {
    scrollToTop();
  }, [currentJobs]);

  const MAX_LENGTH = 250;

  function scrollToTop() {
    window.scrollTo(0, 0);
  }

  const [formData, setFormData] = useState({
    priceRangeLower: "0",
    priceRangeGreator: "10",
    projectType: "Fixed",
    location: "",
    complexity: "all",
    skill: "all"
  });

  const onChangeVal = (e) => {
    const { name, value } = e.target;

    // Check if the input value is a valid number
    if (value && isNaN(Number(value))) {
      // If not, set the error message
      setError("Price range can only be in numbers");
    } else {
      // If it's a valid number, clear the error message
      setError("");
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onChangeVal2 = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const applyForJob = async (e) => {
    applyforjob.id = e;
    history.push("/applyforjob");
  };

  const [state, setstate] = useState({
    value: { min: 10, max: 1000 },
  });

  const [value, setValue] = useState("");

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  //const storedValue = JSON.parse(localStorage.getItem('search'));
  const homepage_query = useLocation();
  const searchParams = new URLSearchParams(homepage_query.search);
  const storedValue = searchParams.get("value");
  const [showJobDetail, setShowJobDetail] = useState(false);


  useEffect(() => {
    if (storedValue) {
      handleSearch();
    } else {
      if (postJobDataAll !== null) {
        const reversedData = postJobDataAll?.map((item) => ({
          headline: item.headline,
          location: item.location,
          description: item.description,
          payment: item?.payment_amount,
          paymentType: item?.payment_type_id?.type_name,
          manager_name: item?.hire_manager_id?.first_name,
          jobProgress: item.job_progress,
          skills: [item.main_skill_id],
          jobposttime: item.job_post_time,
          _id: item._id,
        })).reverse();

        setPostJobData(reversedData);
      }
    }
  }, [postJobDataAll, storedValue]);

  const countries = Country.getAllCountries();

  //console.log(postJobDataAll);
  //console.log(postJobData1);

  
  useEffect(() => {
    if (user.type == "freelancer" && freelancerprofile.verification == true) {
      console.log(freelancerprofile.verification);
      setShowPage(true);
    }
  }, []);

  const handleSearch = () => {
    // filter the postJobDataAll array based on the value entered in the search bar
    const filteredList = postJobDataAll.filter(
      (job) =>
        job.headline.toLowerCase().includes(value.toLowerCase()) ||
        job.description.toLowerCase().includes(value.toLowerCase()) ||
        (job.location &&
          job.location.toLowerCase().includes(value.toLowerCase())) ||
        (job.payment_amount &&
          job.payment_amount.toString().includes(value.toLowerCase()))
    );

    //console.log(value);
    //console.log(filteredList);

    // update the postJobDataAll with the filtered list
    //setFilteredJobData(filteredList);
    setPostJobData(filteredList);

    if (filteredList.length > 0) {
      setPostJobData(
        filteredList.map((item) => ({
          headline: item.headline,
          location: item.location,
          description: item.description,
          payment: item.payment_amount,
          paymentType: item.payment_type_id.type_name,
          manager_name: item.hire_manager_id.first_name,
          jobProgress: item.job_progress,
          skills: [item.main_skill_id],
          jobposttime: item.job_post_time,
          _id: item._id,
        }))
      );
    }

    //console.log(postJobData1);
    //console.log(filteredJobData);

    setCurrentPage(1);
  };


  const clearFilter = () => {
    setFormData({
      priceRangeLower: "0",
      priceRangeGreator: "10",
      projectType: "Fixed",
      location: "",
      complexity: "all",
      skill: "all"
    });
    setPostJobData(
      postJobDataAll?.map((item) => ({
        headline: item.headline,
        location: item.location,
        description: item.description,
        payment: item.payment_amount,
        paymentType: item.payment_type_id.type_name,
        manager_name: item.hire_manager_id.first_name,
        jobProgress: item.job_progress,
        skills: [item.main_skill_id],
        jobposttime: item.job_post_time,
        _id: item._id,
      }))
    );
  };

  const searchSort = (search) => {
    if(search === ""){
      setPostJobData(
        postJobDataAll?.map((item) => ({
          headline: item.headline,
          location: item.location,
          description: item.description,
          payment: item?.payment_amount,
          paymentType: item?.payment_type_id?.type_name,
          manager_name: item?.hire_manager_id?.first_name,
          jobProgress: item.job_progress,
          skills: [item.main_skill_id],
          jobposttime: item.job_post_time,
          _id: item._id,
        }))
      );
      return;
    }
    const filteredList = postJobDataAll.slice().sort(
    (jobOne,jobTwo) => {
      if(search === 'alphabetic'){
        console.log('alphas');
        return jobOne.headline.toLowerCase().localeCompare(jobTwo.headline.toLowerCase())
      }else{
        return jobTwo.headline.toLowerCase().localeCompare(jobOne.headline.toLowerCase())
      }
      
    });

    //console.log(value);

    // update the postJobDataAll with the filtered list
    //setFilteredJobData(filteredList);
    setPostJobData(filteredList);

    if (filteredList.length > 0) {
      setPostJobData(
        filteredList.map((item) => ({
          headline: item.headline,
          location: item.location,
          description: item.description,
          payment: item.payment_amount,
          paymentType: item.payment_type_id.type_name,
          manager_name: item.hire_manager_id.first_name,
          jobProgress: item.job_progress,
          skills: [item.main_skill_id],
          jobposttime: item.job_post_time,
          _id: item._id,
        }))
      );
  
    }

    //console.log(postJobData1);
    //console.log(filteredJobData);

    setCurrentPage(1);
  }

  const filtersearch = () => {

    const { priceRangeLower, priceRangeGreator, projectType, location, complexity, skill } = formData;

    const filteredList = postJobDataAll.filter(
      (job) =>
        job.payment_type_id.type_name
          .toLowerCase()
          .includes(projectType.toLowerCase()) && 
          job.payment_amount >= parseFloat(priceRangeLower) &&
        job.payment_amount <= parseFloat(priceRangeGreator) &&
        (complexity !== "all" ? job.complexity_id?.complexity === complexity : true) &&
        (skill !== "all" ? job.main_skill_id?.skill_name === skill : true)
    );

    setPostJobData(filteredList);

    if (filteredList.length > 0) {
      setPostJobData(
        filteredList.map((item) => ({
          headline: item.headline,
          location: item.location,
          description: item.description,
          payment: item.payment_amount,
          paymentType: item.payment_type_id.type_name,
          manager_name: item.hire_manager_id.first_name,
          jobProgress: item.job_progress,
          skills: [item.main_skill_id],
          jobposttime: item.job_post_time,
          _id: item._id,
        }))
      );
    }

    setCurrentPage(1);
  };

  const handleFilterAndClose = () => {
    filtersearch();
    setShow(false);
  };

  const openJobDetails = async (e) => {
    jobDetailData._id = e._id;
    jobDetailData.paymentType = e.paymentType;
    jobDetailData.payment = e.payment;
    jobDetailData.headline = e.headline;
    jobDetailData.location = e.location;
    jobDetailData.description = e.description;
    jobDetailData.manager_name = e.manager_name;
    jobDetailData.skill = e.skills[0];
    skillsGetbyId(jobDetailData.skill);
    setShowJobDetail(true);
  };


  const handleCloseJobDetail = () => setShowJobDetail(false);

  //console.log(postJobData1);
  /*
  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }*/


  if (user.type === "Freelancer" && !isfreelancerActionable) {
    return (
      <div className="account-review">
        <h5 className="text-primary text-center mb-0">Your account is under review, and will be activated soon</h5>
      </div>
    );
  } else {
    return (
      <section className="main-page page-dashboard page-talent">
        <div className="container">
          <Alert />
          <section className="bg-white rounded shadow-sm p-5 mb-3">
            <div className="row advanced-search">
              {/*!freelancerStatus && <div className="col-md-12 px-5">
          <div className="row d-flex align-items-center justify-content-between">
            <h5>Your Profile Is not active for bidding Kindly activate your profile</h5>
            <button className="btn btn-secondary" onClick={() =>dispatch(updateFreelancer())}>Activate</button>
          </div>
        </div>*/}

              <div className="col-md-10">
                <div className="input-group search-engine">
                  <Search
                    suggestions={skills.length > 0 ? skills.map(item => item.skill_name) : []}
                    setInput={setValue}
                    handleSearch={handleSearch}
                    pre_value={value}
                  />
                </div>
              </div>
              <div className="col-md-2 pl-0">
                <Button
                  onClick={handleShow}
                  className="btn btn-block btn-primary"
                >
                  <Icon icon={filter} /> Filters
                </Button>
                <Modal
                  show={show}
                  size="sm"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  onHide={handleClose}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Search Jobs</Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                    <div className="container">
                      <div className="row">
                        <div className="col-md-12">
                          <div>
                            <label className="form-label">Price Range</label>
                            <div className="mt-2 filter-price-search">
                              <div>

                              <Input2
                                labelFor={`Price Range`}
                                placeholder={`0`}
                                required={true}
                                type={"text"}
                                name={"priceRangeLower"}
                                value={formData.priceRangeLower}
                                handlerOnChange={(e) => onChangeVal(e)}
                              />
                              </div>
                              <div>
                                
                              <Input2
                                labelFor={`Price Range`}
                                placeholder={`10`}
                                required={true}
                                type={"text"}
                                name={"priceRangeGreator"}
                                value={formData.priceRangeGreator}
                                handlerOnChange={(e) => onChangeVal(e)}
                              />
                              </div>
                              {error && (
                                <div style={{ color: "red" }}>{error}</div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12 mb-2">
                          <label className="form-label">Project Type</label>
                          <ul className="options-list mt-2">
                            <li>
                              <input
                                name="projectType"
                                value="Hourly"
                                onChange={(e) => onChangeVal2(e)}
                                type="radio"
                                checked={formData.projectType == "Hourly"}
                              />{" "}
                              Hourly
                            </li>
                            <li>
                              <input
                                name="projectType"
                                value="Fixed"
                                onChange={(e) => onChangeVal2(e)}
                                type="radio"
                                checked={formData.projectType == "Fixed"}
                              />{" "}
                              Fixed
                            </li>
                          </ul>
                        </div>

                        <div className="col-md-12 mb-2">
                          <div>
                            <label className="form-label">Complexity</label>
                            <div className="mt-2 filter-price-search">
                              <div className="w-100">
                                <select
                                  name="complexity"
                                  value={formData.complexity}
                                  className="form-control"
                                  onChange={onChangeVal2}
                                >
                                  <option value="all">All</option>
                                  {complexityLevel?.length > 0 ? complexityLevel.map(c => (
                                    <option value={c.complexity} key={c.complexity}>{c.complexity}</option>
                                  )) : ""}
                                </select>
                              </div>
                              {error && (
                                <div style={{ color: "red" }}>{error}</div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12 mb-2">
                          <div>
                            <label className="form-label">Skill</label>
                            <div className="mt-2 filter-price-search">
                              <div>
                                <select
                                  name="skill"
                                  value={formData.skill}
                                  className="form-control"
                                  onChange={onChangeVal2}
                                >
                                  <option value="all">All</option>
                                  {skills?.length > 0 ? skills.map(s => (
                                    <option value={s.skill_name} key={s.skill_name}>{s.skill_name}</option>
                                  )) : ""}
                                </select>
                              </div>
                              {error && (
                                <div style={{ color: "red" }}>{error}</div>
                              )}
                            </div>
                          </div>
                        </div>

                      </div>

                      {/*<div className="row mt-3">
                  <div className="col-md-12">

                    <div className="form-group cyber-form-control">
                       
                      <label className="form-label">Country/Location</label>
                      <div className="input-group mb-3">
                        <select className="form-control"
                          name="location"
                          value={location}
                          onChange={(e) => onChangeVal2(e)}>
                          <option>Please Select</option>
                          {
                            countries.map(item => <option value={item.name} data-isoCode={item.isoCode}>{item.name}</option>)
                          }
                        </select>
                      </div>
                        </div>

                  </div>
                </div>
                */}
                    </div>
                  </Modal.Body>

                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={handleFilterAndClose}
                      disabled={error}
                    >
                      Apply Filter
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </section>

          <section className="bg-white rounded shadow-sm">
            <div className="d-flex justify-content-between">

            <div className="pt-4 px-4">
              {postJobData1 === null ? (
                <Skeleton width={100} height={20} />
              ) : (
                <>
                  <strong>{postJobData1.length}</strong> Jobs found
                </>
              )}
            </div>
            {/* <div className="pt-4 px-4">
              <select className="form-control" onChange={(e)=>searchSort(e.target.value)}>
                <option value="">Select Sort</option>
                <option value="alphabetic">A-Z sort</option>
                <option value="alphabetic_reverse">Z-A sort</option>
              </select>
            </div> */}
            <div
              className="pt-4 px-4 text-primary cursor-pointer"
              onClick={clearFilter}
            >
              Clear Filters
            </div>
            </div>

            {postJobData1 === null ? (
              [0,1,2,3,4].map(i => (
                <div key={i} className="border-bottom p-4 posted-jobs">
                  <div className="pt-1">
                    <div className="row">
                      <div className="col-md-10">
                        <Skeleton width={180} height={20} />
                        <div className="mb-2">
                          <Skeleton width={150} height={17} />
                        </div>
                        <div>
                          <div className="mb-2">
                            <Skeleton width={170} height={17} />
                          </div>
                          <Skeleton height={15} count={3} />
                          <Skeleton width={100} height={15} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
            
              <>
            <Modal
                    show={showJobDetail}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    onHide={handleCloseJobDetail}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>
                        Job Detail - {jobDetailData.headline}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="container">
                        <div className="row">
                          <div className="col-12 job-detail-modal">
                            {jobDetailData && 
                            <>
                            {/* <h6 className="text-primary">Skills</h6>
                            <p className="text-muted text-justify">
                              {skills?.skill_name}
                            </p> */}
                            <h6 className="text-primary">Description</h6>
                            <p className="text-muted text-justify">
                              {jobDetailData?.description}
                            </p>
                            <h6 className="text-primary">Budget Type</h6>
                            <p className="text-muted">
                              {jobDetailData?.paymentType}
                            </p>
                            <h6 className="text-primary">Budget Amount</h6>
                            <p className="text-muted">
                              {jobDetailData?.payment}
                            </p>
                            <h6 className="text-primary">Posted By</h6>
                            <p className="text-muted">
                              {jobDetailData?.manager_name}
                            </p>
                            <h6 className="text-primary">Location</h6>
                            <p className="text-muted">
                              {jobDetailData?.location}
                            </p></>}
                          </div>
                        </div>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={handleCloseJobDetail}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
            {currentJobs.length > 0 ? (
              currentJobs.length > 0 &&
              [...currentJobs].reverse().map((jobDataItem, index) => (
                <>
                  <div className="border-bottom p-4 posted-jobs" key={index}>
                    <div className="pt-1">
                      <div className="row">
                        <div className="col-md-10">
                          <span
                            onClick={() => openJobDetails(jobDataItem)}
                            className="cursorClass"
                          >
                            <h4
                              className="h4 mt-0 mb-3"
                              style={{ color: "#23adf7" }}
                            >
                              {jobDataItem.headline}
                            </h4>
                            <div className="mb-2">
                              <strong>Posted By</strong>
                              {"  "}
                              {jobDataItem.manager_name}
                            </div>
                            <div className="text-gray">
                              <div className="mb-2 list-detail-items">
                                <ul>
                                  <li>
                                    <strong>Budget</strong> $
                                    {jobDataItem.payment}{" "}
                                    {jobDataItem.paymentType}
                                  </li>
                                  <li>
                                    <strong>Posted</strong>{" "}
                                    {moment
                                      .utc(jobDataItem.jobposttime)
                                      .format("DD/MM/YYYY")}
                                  </li>
                                </ul>
                              </div>
                              {jobDataItem?.description?.length > MAX_LENGTH ? (
                                <p>
                                  {`${jobDataItem.description.substring(
                                    0,
                                    MAX_LENGTH
                                  )}`}{" "}
                                  ....
                                </p>
                              ) : (
                                <p className="mb-3">
                                  {jobDataItem.description}
                                </p>
                              )}
                              {jobDataItem.location && (
                                <>
                                  <strong>
                                    <SVGLocation />
                                  </strong>{" "}
                                  <span className="text-muted">
                                    {jobDataItem.location}
                                  </span>
                                </>
                              )}
                            </div>
                          </span>
                        </div>
                        <div className="col-md-2">
                        <button
                            onClick={() => {
                              applyForJob(jobDataItem._id)
                            }}
                            className="btn btn-primary btn-sn"
                          >
                            Apply for Job
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ))
            ) : (
              <div className="mt-5 p-5">
                <h6 className="text-primary text-center mb-0">
                  No Search Result Found
                </h6>
              </div>
            )}
              </>
            )}
            {/*postJobDataAll.length == 0 ?
        <div className="mt-5 p-5">
          <h6 className="text-primary text-center mb-0">No Jobs available</h6>
        </div>
              : ""*/}
          </section>
        </div>
        <br />
        {/* Display the navigation buttons */}
        {totalPages > 1 && (
          <nav>
            <ul className="pagination justify-content-center">
              {[...Array(totalPages)].map((_, index) => {
                const pageNumber = index + 1;
                return (
                  <li
                    key={pageNumber}
                    className={`page-item ${
                      pageNumber === currentPage ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                );
              })}
            </ul>
          </nav>
        )}
      </section>
    );
  }
};

const mapStateToProp = (state) => ({
  auth: state.auth,
  clientProfile: state.clientProfile,
  postJob: state.postJob,
  freelancerProfile: state.freelancerProfile,
});

export default connect(mapStateToProp, {
  setAlert,
  postJobGetAll,
  deleteJob,
  complexityGetbyId,
  expectedDurationGetbyId,
  paymentTypeGetbyId,
  skillsGetbyId,
  skillsGet,
  complexityGet
})(Job);

